import { render, staticRenderFns } from "./ReferenceDetails.vue?vue&type=template&id=20ca2998&"
import script from "./ReferenceDetails.vue?vue&type=script&lang=js&"
export * from "./ReferenceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports